export default "__VITE_ASSET__Cgc2itwo__"